import React from 'react';
import { Link } from 'react-router-dom';

import PropTypes from 'prop-types';

import { Badge } from 'apps/auth/components/common/Badge/Badge';
import { Icon } from 'apps/auth/components/common/Icon/Icon';
import clsx from 'clsx';

import styles from './NotificationWrapper.module.css';

const NotificationWrapper = (props) => {
    const Wrapper = props.isTagA ? 'a' : Link;
    const dynamicPropName = props.isTagA ? 'href' : 'to';

    return (
        <Wrapper
            {...{ [dynamicPropName]: props.url ? props.url : '#' }}
            onClick={props.onClick}
            className={clsx(styles.wrapper, props.isNewMainScreen && styles.newMainScreen, props.isLeftAligned && styles.leftAligned)}
        >
            {props.isLeftAligned && <Icon name={props.iconName} color={'primary'} rightIndent={'12px'} />}
            <span>{props.title}</span>
            {props.isNewMainScreen && (
                <span className={styles.badgeWrap}>
                    <Badge size={'tight'} variant={'negative'} />
                </span>
            )}
            {!props.isNewMainScreen && !props.isLeftAligned && (
                <span className={styles.iconWrap}>
                    <Icon name={'bell-ringing'} color={'primary'} />
                    <Badge size={'tight'} variant={'negative'} className={styles.dot} />
                </span>
            )}
        </Wrapper>
    );
};
NotificationWrapper.propTypes = {
    title: PropTypes.string.isRequired,
    url: PropTypes.string,
    onClick: PropTypes.func,
    isTagA: PropTypes.bool,
    isLeftAligned: PropTypes.bool,
    isNewMainScreen: PropTypes.bool,
    iconName: PropTypes.string,
};
export default NotificationWrapper;
